import React from 'react';
import ServiceBookingPage from '../ServiceBookingPage';

const packs = [
  {
    id: 'headshot_express',
    emoji: '⚡',
    name: 'Headshot Express',
    description: '30 min | 3 retouched HD photos',
    price: 1500000,
    duration: '30 min',
    features: ['3 retouched HD photos', 'Neutral backdrop', 'Delivery within 48h']
  },
  {
    id: 'personal_brand_basic',
    emoji: '📸',
    name: 'Personal Brand Basic',
    description: '1h | 10 retouched photos | 2 backdrops',
    price: 3500000,
    duration: '1 hour',
    features: ['10 retouched photos', '2 different backdrops', '2 outfit changes', 'Delivery within 48h']
  },
  {
    id: 'personal_brand_pro',
    emoji: '🌟',
    name: 'Personal Brand Pro',
    description: '2h | 25 retouched photos | 3 setups',
    price: 6500000,
    duration: '2 hours',
    popular: true,
    features: ['25 retouched photos', '3 different setups', '3 outfit changes', 'Delivery within 48h']
  },
  {
    id: 'brand_identity_full',
    emoji: '💎',
    name: 'Brand Identity Full',
    description: 'Half day | Unlimited photos | 4 setups',
    price: 12000000,
    duration: 'Half day',
    features: ['Unlimited photos', '4 different setups', 'Studio lifestyle shooting', '20 retouched HD photos']
  },
  {
    id: 'youtube_thumbnails',
    emoji: '🎬',
    name: 'YouTube Thumbnails Pack',
    description: '1h | 10 ready-to-use thumbnails',
    price: 2500000,
    duration: '1 hour',
    features: ['10 retouched thumbnails', 'Custom colored backdrops', 'Text and design integrated', 'Delivery within 24h']
  },
  {
    id: 'course_visuals',
    emoji: '🎓',
    name: 'Course Visuals Pack',
    description: '1h30 | 15 photos for sales page + covers',
    price: 4000000,
    duration: '1.5 hours',
    features: ['15 retouched HD photos', 'Sales page ready', 'Module covers', 'Delivery within 48h']
  }
];

const addons = [
  { id: 'extra_retouch', name: 'Extra retouch per photo', price: 150000 },
  { id: 'custom_backdrop', name: 'Custom colored backdrop', price: 300000 },
  { id: 'hair_makeup', name: 'Hair & makeup (partner)', price: 500000 },
  { id: 'video_60s', name: '60s presentation video', price: 1500000 },
  { id: 'express_24h', name: 'Express 24h delivery', price: 500000 },
  { id: 'text_overlay', name: 'Text overlay on photos', price: 200000, description: 'Per photo' }
];

const customFields = [
  { id: 'shoot_purpose', label: 'What is this shoot for?', type: 'text', placeholder: 'LinkedIn, course launch, website...' },
  { id: 'outfit_count', label: 'How many outfits will you bring?', type: 'number', placeholder: '2' }
];

export default function PhotoStudioBookingPage() {
  return (
    <ServiceBookingPage
      serviceType="photo_studio"
      serviceTitle="Photo Studio"
      serviceSubtitle="Professional visual content"
      packs={packs}
      addons={addons}
      customFields={customFields}
      backLink="/services/photo-studio"
    />
  );
}
